import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal } from 'carbon-components-react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { ExpandableCard } from '../../../components';
import { deleteDmService } from '../../../services/Api';

class Drafts extends Component {
  constructor() {
    super();

    this.state = {
      selectedId: null,
      deleteModal: false,
    };
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
      selectedId: null,
    }));
  };

  deleteOrder = async () => {
    const { selectedId } = this.state;
    const { loadDrafts } = this.props;
    try {
      await deleteDmService('/Pedido/Delete', selectedId);
      await loadDrafts();
      this.toggleDeleteModal();
      toast.success('Pedido removido com sucesso');
    } catch (e) {
      toast.error('Não foi possível remover o pedido');
    }
  };

  render() {
    const { drafts, history } = this.props;
    const { deleteModal } = this.state;
    if (!drafts.length) {
      return <h3>Nenhum pedido em rascunho!</h3>;
    }

    return (
      <div>
        {drafts.map(item => (
          <div key={item.id}>
            <ExpandableCard
              title={item.descricao}
              onClick={() => history.push(`/comunicacao/campanha/${item.id}/informacoes`)}
              description={`Última edição em:
                ${item.dataEdicao ? moment(item.dataEdicao).format('DD/MM/YYYY [às] HH:mm') : ''}`}
              leftComponent={() => (
                <button
                  className="button button--clear danger h-sm-margin sm-padding"
                  type="submit"
                  onClick={e => {
                    e.stopPropagation();
                    this.toggleDeleteModal();
                    this.setState({ selectedId: item.id });
                  }}
                >
                  <i className="material-icons">delete_outline</i>
                </button>
              )}
              rightComponent={() => <div className="button h-sm-margin sm-padding">editar</div>}
            />
          </div>
        ))}
        <Modal
          open={deleteModal}
          onRequestSubmit={this.deleteOrder}
          onRequestClose={this.toggleDeleteModal}
          modalHeading="Apagar pedido dos rascunhos"
          primaryButtonText="Tenho certeza"
          secondaryButtonText="Cancelar"
        >
          <div className="warning-modal-txt">
            <p>Você tem certeza que deseja apagar este rascunho?</p>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(Drafts);



// WEBPACK FOOTER //
// ./src/screens/client/campaigns/Drafts.js